// Utility to select the correct compatibility score based on mode or toggles
// Usage: selectCompatibility({ compatibility, average_compatibility, modeMatch, leftToggle, rightToggle })

export function selectCompatibility({ compatibility, average_compatibility, modeMatch, leftToggle, rightToggle }) {
  if (modeMatch === "both_mode" || (leftToggle && rightToggle)) {
    return average_compatibility ?? compatibility?.light ?? compatibility?.dark ?? 0;
  }
  if (modeMatch === "light_mode" || leftToggle) {
    return compatibility?.light ?? 0;
  }
  if (modeMatch === "dark_mode" || rightToggle) {
    return compatibility?.dark ?? 0;
  }
  return 0;
}
